import { render } from "./IconGitHub.vue?vue&type=template&id=94ac0348"
import script from "./IconGitHub.vue?vue&type=script&lang=js"
export * from "./IconGitHub.vue?vue&type=script&lang=js"
script.render = render

export default script